import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import Icon from '../Icon';
import UserCard from '../Card/UserCard';
import { getUser } from './utils/getUser';
import { COLORS } from '../../constants/styles';
import styles from './style.styl';

const FamilyCircle = ({
  relatedPatientId,
  type,
  title,
  list,
  formatMessage,
  isProvider,
  onInvite,
  onOpen,
  hideHeader,
  hasFixedHeight,
}) => (
  <div
    styleName={cn('circle', {
      'circle--fixed': hasFixedHeight,
    })}
  >
    <If condition={!hideHeader}>
      <div styleName="provider-label">
        <span styleName="label">{title}</span>
        <If condition={isProvider}>
          <div styleName="assign-wrapper" onClick={onInvite}>
            <Icon name="assign-blue" size={24} />
            <span styleName="assign-label">
              {formatMessage({ id: 'dialog.common.inviteMember' })}
            </span>
          </div>
        </If>
      </div>
    </If>
    {list.length > 0 &&
      list.map((item, index) => {
        const { role, user } = getUser(item, formatMessage);
        const { pending, isTargetUser } = item;
        return (
          <div key={`${user.id}-${index}`} styleName="family">
            <div styleName="family-header">
              <div styleName="user">
                <UserCard
                  className="ph3 pv2 fw6"
                  user={user}
                  note={role}
                  size={40}
                  linkType={type}
                  disabled={pending || isTargetUser}
                  relatedPatientId={relatedPatientId}
                />
              </div>
              {pending && (
                <p
                  styleName={cn('note', {
                    'note--withPadding': !isProvider,
                  })}
                >
                  {formatMessage({ id: 'common.pending' })}
                </p>
              )}
              <If condition={isProvider}>
                <div styleName="options" onClick={e => onOpen(e, item)}>
                  <Icon
                    name="more"
                    size={12}
                    style={{ fill: COLORS.cloudyBlue }}
                  />
                </div>
              </If>
            </div>
          </div>
        );
      })}
  </div>
);

FamilyCircle.propTypes = {
  relatedPatientId: PropTypes.number,
  type: PropTypes.string,
  title: PropTypes.string,
  list: PropTypes.array,
  formatMessage: PropTypes.func,
  isProvider: PropTypes.bool,
  onInvite: PropTypes.func,
  onOpen: PropTypes.func,
  hideHeader: PropTypes.bool,
  hasFixedHeight: PropTypes.bool,
};

export default CSSModules(FamilyCircle, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/FamilyCircle.jsx